import { Typography } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import clsx from "clsx";
import { useStyles } from "./CommonStyle";
export interface IOverlayLoader {
  message: string;
}
const OverlayLoader = (props: IOverlayLoader) => {
  const classes = useStyles();
  return (
    <div className={clsx(classes.positionComponent, classes.overlayLoader)}>
      <CircularProgress
        sx={{
          height: "10rem",
          width: "10rem",
          color: "#FFF",
          marginBottom: "2rem",
        }}
      />
      <Typography variant="body1" sx={{ fontWeight: "600", color: "#FFF" }}>
        {props.message}
      </Typography>
    </div>
  );
};

export default OverlayLoader;
